module.exports = __webpack_public_path__ + "static/media/48391029_2308811799193998_2140456703546621952_o-thumb.ecf5cb43.jpg";